import React from 'react';

/**
 * Not a true Popover, but similar to the EvPopover. Doesn't use the Material Popover at all.
 * The Material Popover, and the EvPopover by extension, render the Popover at the bottom of the body and then position it absolutely.
 * I kept running into strange positioning quirks and css bleed when using that material popover.
 * Positioning it according to the mocks was really trivial to do with just normal flex/relative positioning.
 *
 * This HOC adds the "Close On Click Outside of the popover" and "Close on Esc" functionality, but doesn't mess with the positioning.
 */
export default function rulePopout(WrappedComponent) {
  return class extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        blockClickOut: false,
      };
      this.handleClickOutside = this.handleClickOutside.bind(this);
      this.handleKeyPress = this.handleKeyPress.bind(this);
      this.blockClickOutTimeout = this.blockClickOutTimeout.bind(this);
    }

    componentDidMount() {
      document.addEventListener('click', this.handleClickOutside, true);
      document.addEventListener('keydown', this.handleKeyPress, true);
    }

    componentWillUnmount() {
      document.removeEventListener('click', this.handleClickOutside, true);
      document.removeEventListener('keydown', this.handleKeyPress, true);
      if (this.timeOutHandler) {
        clearTimeout(this.timeOutHandler);
        this.timeOutHandler = null;
      }
    }

    /**
     * temporarily block click outside from closing from child component call `this.props.blockClickOutTimeout()`
     * to temporarily block click out
     * @param timeout optional timeout period in millisecs
     */
    blockClickOutTimeout(timeout = 1000) {
      if (this.timeOutHandler) {
        clearTimeout(this.timeOutHandler);
      }
      this.setState({blockClickOut: true});
      this.timeOutHandler = setTimeout(() => this.setState({blockClickOut: false}), timeout);
    }

    /**
     * Event handler for mouse click.  Fires parent event if the click is outside the search results box
     */
    handleClickOutside(event) {
      if (
        !this.state.blockClickOut &&
        this.popoutContainer &&
        !this.popoutContainer.contains(event.target) &&
        !event.path.find(i => i.className === 'search-results') &&
        this.props.closeRequest
      ) {
        this.props.closeRequest('cancel');
      }
    }

    /**
     * Event handler for keypress.  Fires parent event if the key == Escape
     */
    handleKeyPress(event) {
      event = event || window.event;
      let isEscape = false;
      if ('key' in event) {
        isEscape = event.key === 'Escape' || event.key === 'Esc';
      } else {
        isEscape = event.keyCode === 27;
      }
      if (isEscape && this.props.closeRequest) {
        this.props.closeRequest('escape');
      }
    }

    render() {
      return (
        <div ref={c => (this.popoutContainer = c)}>
          <WrappedComponent {...this.props} blockClickOutTimeout={this.blockClickOutTimeout} />
        </div>
      );
    }
  };
}
